module.exports = __webpack_public_path__ + "static/media/graphic-design-icon.3d93be53.svg";